export const vendorPublishingStrategy = ({
  vendor
}) => ({
  message,
  channel
}) => vendor.publish({
  channelId: channel,
  data: JSON.stringify(message),
  messageId: message.id
});